var _excluded = ["item", "onClick", "onRecentSearch"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import Avatar from '@domain-group/fe-co-avatar';
import { BuildingIcon, HouseIcon, SchoolIcon, PinIcon, StreetIcon, HistoryIcon } from '@domain-group/fe-co-icon';
import BaseOptionCard from './base-option-card';
import * as styles from './option-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var makeCard = props => {
  var _props$item, _props$item2;
  return ___EmotionJSX(BaseOptionCard, _extends({
    title: (_props$item = props.item) === null || _props$item === void 0 ? void 0 : _props$item.name,
    label: (_props$item2 = props.item) === null || _props$item2 === void 0 ? void 0 : _props$item2.description
  }, props));
};
export var GenericCard = makeCard;
export var LocalityCard = props => makeCard(_objectSpread(_objectSpread({}, props), {}, {
  icon: ___EmotionJSX(PinIcon, null)
}));
export var DivisionCard = props => makeCard(_objectSpread(_objectSpread({}, props), {}, {
  icon: ___EmotionJSX(PinIcon, null)
}));
export var AddressCard = props => makeCard(_objectSpread(_objectSpread({}, props), {}, {
  icon: ___EmotionJSX(HouseIcon, null)
}));
export var StreetCard = props => makeCard(_objectSpread(_objectSpread({}, props), {}, {
  icon: ___EmotionJSX(StreetIcon, null)
}));
export var SchoolCard = props => makeCard(_objectSpread(_objectSpread({}, props), {}, {
  icon: ___EmotionJSX(SchoolIcon, null)
}));
export var DevelopmentCard = props => makeCard(_objectSpread(_objectSpread({}, props), {}, {
  icon: ___EmotionJSX(BuildingIcon, null)
}));
export var AgencyCard = props => makeCard(_objectSpread(_objectSpread({}, props), {}, {
  icon: ___EmotionJSX(BuildingIcon, null)
}));
export var AgentCard = props => makeCard(_objectSpread(_objectSpread({}, props), {}, {
  icon: ___EmotionJSX(Avatar, {
    css: styles.avatar,
    imageUrl: props.item.image,
    size: "custom"
  })
}));
export var RecentItemCard = _ref => {
  var _item$value, _item$value$, _item$value2;
  var item = _ref.item,
    onClick = _ref.onClick,
    _ref$onRecentSearch = _ref.onRecentSearch,
    onRecentSearch = _ref$onRecentSearch === void 0 ? () => {} : _ref$onRecentSearch,
    props = _objectWithoutProperties(_ref, _excluded);
  var handleClick = event => onClick ? onClick(event) : onRecentSearch(item.value);
  return makeCard(_objectSpread({
    item: {
      name: item.label,
      description: ((_item$value = item.value) === null || _item$value === void 0 ? void 0 : _item$value.length) === 1 ? (_item$value$ = item.value[0]) === null || _item$value$ === void 0 ? void 0 : _item$value$.description : "".concat((_item$value2 = item.value) === null || _item$value2 === void 0 ? void 0 : _item$value2.length, " Locations")
    },
    appearance: 'immediate',
    icon: ___EmotionJSX(HistoryIcon, null),
    onClick: handleClick
  }, props));
};